import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

export const ChartGrid = styled.div`
    height: 70vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: ${theme.space[24]};
    padding-top: ${theme.space[8]};
`;
